module.exports = __webpack_public_path__ + "static/media/10 - Rim 2.aa8cad4a.wav";